import type { PageContext } from '@template-project/funnels-contract';
import type { CartEntity } from '@/domain/entities/cart.entity';

/** Authoritative cart snapshot consumed by funnels-go transition evaluation. */
export function toFunnelCartPageContext(
  cart: CartEntity,
  pageType: PageContext['pageType'] = 'cart',
): Partial<PageContext> {
  return {
    pageType,
    cartToken: cart.token,
    cartTotal: cart.totals.total.display,
    cartItemCount: cart.items.reduce((sum, item) => sum + item.quantity, 0),
    cartProductIds: [...new Set(cart.items.map((item) => item.product_id))],
  };
}
